const SummaryTransformer = (content, length) => {
  let transformedContent = ""
  const summaryContent = content.summary
  const fullContent = content.processed
  if (summaryContent) {
    transformedContent = summaryContent
  } else if (fullContent) {
    transformedContent = fullContent.replace(/(<([^>]+)>)/gi, "")
    const searchKey = "^(.{" + length + "}[^\\s]*).*"
    const regex = new RegExp(searchKey, "s")
    transformedContent = transformedContent.replace(regex, "$1") + " ..."
  }
  return transformedContent
}

export default SummaryTransformer
